import React, { useEffect, useState } from 'react';
import {
  Card,
  CardHeader,
  CardBody,
  Container,
  Row,
  Col,
  Table,
  Spinner,
  FormGroup,
  Input
} from 'reactstrap';
import { Phone, PlusCircle } from 'react-bootstrap-icons';
import { useTranslation } from 'react-i18next';
import SimpleHeader from '../../components/Headers/SimpleHeader';
import client from '../../utils/client';

const defaultYear = new Date().getFullYear();
const nrOfYears = defaultYear - 2009 + 1;
const options = Array.from({ length: nrOfYears }, (_, i) => defaultYear - i).map((i) => (
  <option key={i} value={i}>
    {i}
  </option>
));

const Visitors = () => {
  const { t } = useTranslation();

  const [inProgress, setInProgress] = useState(null);
  const [visitors, setVisitors] = useState(null);
  const [year, setYear] = useState(defaultYear);

  useEffect(() => {
    document.body.classList.add('visits');
    return () => document.body.classList.remove('visits');
  }, []);

  useEffect(() => {
    (async () => {
      setInProgress(true);
      const { data } = await client(`admin-gc/statistics/golfclub/visitors?year=${year}`);
      setVisitors(data);
      setInProgress(null);
    })();
  }, [year]);

  return (
    <>
      <SimpleHeader name={t('statistic-visitors.title', 'Statistik')} />

      <Container className="mt--6" fluid>
        <Row>
          <Col xs="12" md="9">
            <Row>
              <Col>
                <Card>
                  <CardHeader>
                    <h3 className="mb-0">{t('statistic-visitors.sub-title', 'Besökare')}</h3>
                  </CardHeader>
                  <CardBody>
                    <FormGroup>
                      <Input type="select" onChange={(e) => setYear(e.target.value)}>
                        {options}
                      </Input>
                    </FormGroup>
                    {inProgress && <Spinner />}
                    <Table responsive>
                      <thead className="thead-light">
                        <tr>
                          <th>{t('default.date')}</th>
                          <th>{t('default.name')}</th>
                          <th>{t('default.country', 'Land')}</th>
                          <th>{t('default.card-number')}</th>
                          <th>{t('statistic-visitors.plus-visit', 'PLUS besök')}</th>
                          <th>App</th>
                        </tr>
                      </thead>
                      <tbody>
                        {visitors?.map((v) => (
                          <tr key={v.id}>
                            <td>{v.date}</td>
                            <td>{v.name}</td>
                            <td>{v.nationality}</td>
                            <td>{v.cardNr}</td>
                            <td>{v.ghPlus > 0 && <PlusCircle />}</td>
                            <td>{v.registrationType === 'APP' && <Phone />}</td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Visitors;
